import angular from 'angular';

export class FooterComponent {
  constructor(screenSize, $location) {
    'ngInject';
    var that = this;
    this.isScreenSize = screenSize.is;
    this.mobile = screenSize.is('xs' /*, sm'*/ );
    this.mobile = screenSize.on('xs' /*, sm'*/ , function (match) {
      that.mobile = match;
    });

    this.show = true;

    if (
      $location.path() == "/wanted" ||
      $location.path() == "/direct-dr-member-authors"
    ) {
      this.show = false;
    }
  }
}

export default angular.module('directives.footer', [])
  .component('footer', {
    template: require('./footer.html'),
    controller: FooterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js